import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { LanguageToggle } from './LanguageToggle';
import { Menu, X } from 'lucide-react';

export const Header = ({ t, language, onLanguageChange, onNavigate }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(prev => window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { key: 'services', label: t.nav.services },
    { key: 'process', label: t.nav.process },
    { key: 'testimonials', label: t.nav.testimonials },
    { key: 'faq', label: t.nav.faq },
    { key: 'contact', label: t.nav.contact }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-[#001f3f]/95 backdrop-blur-lg shadow-lg' 
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo - Smaller 100px for header */}
          <button 
            onClick={() => onNavigate('hero')}
            className="flex items-center gap-4 group"
          >
            <img 
              src="/logo.png" 
              alt="Le Phare Administratif" 
              className="h-[100px] w-[100px] object-contain group-hover:scale-105 transition-transform duration-300 drop-shadow-xl"
            />
            <div className="hidden lg:block">
              <h1 className="text-[#FF9955] font-bold text-2xl leading-tight group-hover:text-[#FFB366] transition-colors">
                Le Phare Administratif
              </h1>
              <p className="text-[#FF9955] text-lg">& Gestion</p>
            </div>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navItems.map(item => (
              <button
                key={item.key}
                onClick={() => onNavigate(item.key)}
                className="text-slate-200 hover:text-[#D4AF37] transition-colors text-sm font-medium"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Right side */}
          <div className="flex items-center gap-4">
            <LanguageToggle language={language} onLanguageChange={onLanguageChange} />
            
            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-white p-2"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 border-t border-slate-700 pt-4">
            <div className="flex flex-col gap-3">
              {navItems.map(item => (
                <button
                  key={item.key}
                  onClick={() => {
                    onNavigate(item.key);
                    setIsMobileMenuOpen(false);
                  }}
                  className="text-slate-200 hover:text-[#D4AF37] transition-colors text-left py-2"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};
